import React from 'react'
import { Field, FieldProps, FormikProps } from 'formik'
import { TextArea } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { ModifyContractInput } from '../../../../../common/validations'
import FormFieldWrapper from '../../../../components/FormField'

type ModificationDescriptionFieldProps = {
  form: FormikProps<ModifyContractInput>
}

export const ModificationDescriptionField: React.FC<
  ModificationDescriptionFieldProps
> = ({ form }) => {
  const { t } = useTranslation(['contractModification'])

  return (
    <Field name="description">
      {({ field, meta }: FieldProps<ModifyContractInput['description']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('contractModification:labels.modificationDescription')}
          className="min-tablet:flex-1 phone:mt-8 min-tablet:mt-8"
          meta={meta}
          labelBold
        >
          <TextArea
            id={field.name}
            name={field.name}
            onChange={(e) => form.setFieldValue(field.name, e.target.value)}
            placeholder={t(
              'contractModification:placeholders.modificationDescription'
            )}
            value={meta.value}
          />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
